module.exports = __webpack_public_path__ + "img/5.a9747d86.png";